import { render, staticRenderFns } from "./OfferDetailsModal.vue?vue&type=template&id=69960394&"
import script from "./OfferDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OfferDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports